import { reducer as appReducer } from '@core/js/components/system/App/store/reducer';
import { reducer as userReducer } from '@core/js/hooks/user/store/reducer';
import { reducer as i18nReducer } from '@core/js/hooks/i18n/store/reducer';
import { reducer as authReducer } from '@core/js/hooks/auth/store/reducer';
import { reducer as deviceReducer } from '@core/js/hooks/device/store/reducer';
import { reducer as sessionReducer } from '@core/js/hooks/session/store/reducer';
import { reducer as pageReducer } from '@core/js/components/system/Page/store/reducer';
import { reducer as jackpotsReducer } from '@core/js/hooks/useGetJackpots/store/reducer';
import { reducer as footerReducer } from '@core/js/components/main/Footer/store/reducer';
import { reducer as gamesConfigurationReducer } from '@core/js/hooks/games/store/reducer';
import { reducer as loyaltyPointsReducer } from '@core/js/hooks/loyaltyPoints/store/reducer';
import { reducer as popupsReducer } from '@core/js/components/common/PopupManager/store/reducer';
import { reducer as termsConditionsReducer } from '@core/js/hooks/termsConditions/store/reducer';
import { reducer as socketReducer } from '@core/js/hooks/socket/hooks/useOAPISocket/store/reducer';
import { reducer as liveGamesReducer } from '@core/js/hooks/useLiveGamesIntegration/store/reducer';
import { reducer as promotionsConfigurationReducer } from '@core/js/hooks/promotions/store/reducer';
import { reducer as cookieSettingsReducer } from '@core/js/components/main/CookieSettings/store/reducer';
import { reducer as myAccountSidebarReducer } from '@core/js/components/main/MyAccountSidebar/store/reducer';
import { reducer as formsReducer } from '@core/js/components/common/ChangeForm/hooks/useGetForms/store/reducer';
import { reducer as communicationWidgetsReducer } from '@core/js/components/system/CommunicationWidgets/store/reducer';
import { reducer as sportsbookReducer } from '@core/js/components/system/App/hooks/useSportsbookIntegration/store/reducer';
import { reducer as casinoComponentReducer } from '@core/js/components/main/CasinoComponent/store/reducer';

// @theme
import { reducer as pragmaticPlayReducer } from '@theme/js/components/main/GamesGrid/components/Game/components/PragmaticPlay/store/reducer';

import * as Types from './types';
import * as constants from './constants';

export const staticReducers = {
    [constants.APP_REDUCER]: appReducer,
    [constants.USER_REDUCER]: userReducer,
    [constants.PAGE_REDUCER]: pageReducer,
    [constants.AUTH_REDUCER]: authReducer,
    [constants.I18N_REDUCER]: i18nReducer,
    [constants.FORMS_REDUCER]: formsReducer,
    [constants.DEVICE_REDUCER]: deviceReducer,
    [constants.SOCKET_REDUCER]: socketReducer,
    [constants.FOOTER_REDUCER]: footerReducer,
    [constants.SESSION_REDUCER]: sessionReducer,
    [constants.JACKPOTS_REDUCER]: jackpotsReducer,
    [constants.LIVE_GAMES_REDUCER]: liveGamesReducer,
    [constants.SPORTSBOOK_REDUCER]: sportsbookReducer,
    [constants.LOYALTY_POINTS_REDUCER]: loyaltyPointsReducer,
    [constants.COOKIE_SETTINGS_REDUCER]: cookieSettingsReducer,
    [constants.TERMS_CONDITIONS_REDUCER]: termsConditionsReducer,
    [constants.CASINO_COMPONENT_REDUCER]: casinoComponentReducer,
    [constants.MY_ACCOUNT_SIDEBAR_REDUCER]: myAccountSidebarReducer,
    [constants.GAMES_CONFIGURATION_REDUCER]: gamesConfigurationReducer,
    [constants.COMMUNICATION_WIDGETS_REDUCER]: communicationWidgetsReducer,
    [constants.PROMOTIONS_CONFIGURATION_REDUCER]: promotionsConfigurationReducer,
    [constants.POPUPS_REDUCER]: popupsReducer as Types.TCommonReducer,
    [constants.PRAGMATIC_PLAY_REDUCER]: pragmaticPlayReducer // @theme
};
